import { toRefs, reactive, computed } from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

export default function() {
  let state = reactive({
    error: null,
    username: null,
    password: null,
    passwordConfirmation: null,
    user: null
  });

  let isValid = computed(() => {
    let { username, password } = state;
    return (
      username !== null &&
      username.length !== 0 &&
      password !== null &&
      password.length !== 0
    );
  });

  let isRegistrationValid = computed(() => {
    let { username, password, passwordConfirmation } = state;
    return (
      username !== null &&
      username.length !== 0 &&
      password !== null &&
      passwordConfirmation == password &&
      password.length !== 0
    );
  });

  const register = () => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(state.username, state.password)
      .then(() => {}, error => (state.error = error))
      .catch(error => {
        // Handle Errors here.
        state.error = error;
      });
  };

  const login = () => {
    firebase
      .auth()
      .signInWithEmailAndPassword(state.username, state.password)
      .then(() => {}, error => (state.error = error))
      .catch(error => {
        // Handle Errors here.
        state.error = error;
      });
  };

  const loginFake = () => {
    firebase
      .auth()
      .signInWithEmailAndPassword("petr.brap@gmail.com", "testik")
      .then(() => {}, error => (state.error = error))
      .catch(error => {
        // Handle Errors here.
        state.error = error;
      });
  };

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {}, error => (state.error = error))
      .catch(error => {
        // Handle Errors here.
        state.error = error;
      });
  };

  return {
    ...toRefs(state),
    isValid,
    isRegistrationValid,
    register,
    login,
    loginFake,
    logout
  };
}
